import modalActions from 'store/modal/actions';
import request from '../../../request/actions';

export const UPDATE_USER_PREFERENCES_START = `UPDATE_USER_PREFERENCES_START`;
export const UPDATE_USER_PREFERENCES_SUCCESS = `UPDATE_USER_PREFERENCES_SUCCESS`;
export const UPDATE_USER_PREFERENCES_FAILURE = `UPDATE_USER_PREFERENCES_FAILURE`;

export const updateUserPreferencesStart = () => ({
  type: UPDATE_USER_PREFERENCES_START,
});

export const updateUserPreferencesSuccess = () => ({
  type: UPDATE_USER_PREFERENCES_SUCCESS,
});

export const updateUserPreferencesFailure = (error) => ({
  type: UPDATE_USER_PREFERENCES_FAILURE,
  error,
});

export const updateUserPreferences = (id, data) => async (dispatch, getState) => {
  const { user } = getState();
  dispatch(updateUserPreferencesStart());
  try {
    const response = await dispatch(request(`/users/${id}/preferences/`, `PUT`, { preferences: data }));
    dispatch(updateUserPreferencesSuccess(response.data));
    dispatch(modalActions.createModal({
      key: `confirm`,
      extraProps: {
        header: { text: `All set!`, img: true },
        confirmCircle: true,
        text: `Your email preferences have been configured. Be sure to look out for your next email to be sent to `,
        emailText: user.byId[user.selected].email,
      },
    }));
    return response.data;
  } catch (error) {
    dispatch(updateUserPreferencesFailure(error.response));
    dispatch(modalActions.createModal({
      key: `confirm`,
      extraProps: {
        header: { text: `Error!`, img: true, error: true },
        confirmCircle: true,
        error: true,
        text: `An error occured, please retry submitting your preferences again.`,
      },
    }));
    return error.response;
  }
};
